<template>
  <section>
    <div class="row">
      <div class="col">
        <b-card no-body>
          <video
            ref="player"
            class="video-js vjs-fluid"
            :lang="$i18n.locale === 'tw' ? 'zh-tw' : $i18n.locale"
          ></video>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'

import videojs from 'video.js'
import videojs_zhtw from 'video.js/dist/lang/zh-TW.json'
import 'videojs-contrib-hls'

import i18n from '@/plugins/i18n.js'

export default {
  i18n,
  name: 'live-streaming-player',
  props: {
    source: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      player: null,
      player_options: {
        language: 'zh-tw',
        autoplay: false,
        preload: 'auto',
        controls: true,
        responsive: true,
        controlBar: {
          skipButtons: {
            forward: 10,
            backward: 10
          }
        },
        sources: [{
          src: this.source,
          type: 'application/x-mpegurl'
        }]
      }
    }
  },
  methods: {
    setPlayer() {
      this.player = videojs(
        this.$refs.player,
        this.player_options,
        () => { this.player.log('on_player_ready', this) }
      )
    }
  },
  created() {
    //alert(`Vue version : ${Vue.version}`)
  },
  mounted() {
    this.setPlayer()
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
</script>